<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Vanessa Robinson is a young Indiana native and is passionate about writing and telling stories. She is pursuing a career in ministry and uses every opportunity to serve her church and community. Robinson is a dedicated wife, daughter, sister, and aunt. She wrote these stories for her nieces and nephews, to whom the book is dedicated.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?dc2c36b2